import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "fill-in-the-blanks-question-container"
};
const _hoisted_2 = {
  class: "question-preamble"
};
const _hoisted_3 = {
  class: "blanks-input-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_blanks_input = _resolveComponent("blanks-input");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t('chapter.question.fillInTheBlanks.title')), 1), _createElementVNode("div", _hoisted_3, [_createVNode(_component_blanks_input, {
    "blanks-data": _ctx.blanksData,
    onContentChange: _ctx.onBlanksInputUpdate
  }, null, 8, ["blanks-data", "onContentChange"])])]);
}